import type { CSSProperties, ReactElement, ReactNode } from 'react';
import { NeonBreadcrumbs, NeonButton } from '@ps-refarch-ux/neon';
import type { Breadcrumb } from '@ps-refarch-ux/neon';
import { NEON_TEXT } from '@/constants/neon-constants';
import {
  pageHeaderContainerStyle,
  headerRowStyle,
  titleStyle,
  descriptionStyle,
} from './page-header.styles';

export interface PageHeaderAction {
  id: string;
  text: string;
  icon?: string;
  type?: string;
  ariaHasPopup?: string;
  onClick?: () => void;
}

export interface PageHeaderProps {
  breadcrumbs: Array<Breadcrumb>;
  breadcrumbsId: string;
  title: string;
  titleClassName?: string;
  action?: PageHeaderAction;
  /** Rendered beside the primary action in the title row */
  secondaryActions?: ReactNode;
  description?: string;
  /** Extra content rendered below the title row (inside the neon text container) */
  children?: ReactNode;
}

const headerActionsStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  flexWrap: 'wrap',
};

export const PageHeader = ({
  breadcrumbs,
  breadcrumbsId,
  title,
  titleClassName,
  action,
  secondaryActions,
  description,
  children,
}: PageHeaderProps): ReactElement => {
  return (
    <div style={pageHeaderContainerStyle}>
      <NeonBreadcrumbs breadcrumbs={breadcrumbs} id={breadcrumbsId ?? 'page-header-breadcrumbs'} />
      <div className={NEON_TEXT} style={pageHeaderContainerStyle}>
        <div style={headerRowStyle}>
          <div className={titleClassName} style={titleStyle}>
            {title}
          </div>
          {(action || secondaryActions) && (
            <div style={headerActionsStyle}>
              {secondaryActions}
              {action && (
                <NeonButton
                  id={action.id}
                  dataType={action.type ?? 'primary'}
                  dataText={action.text}
                  dataIcon={action.icon}
                  dataAriaHaspopup={action.ariaHasPopup}
                  onClick={action.onClick}
                />
              )}
            </div>
          )}
        </div>
        {description && <p style={descriptionStyle}>{description}</p>}
        {children}
      </div>
    </div>
  );
};
